import { Link, useParams } from 'react-router-dom'
import { FileText, Printer, BarChart2, Briefcase, TrendingUp, DollarSign } from 'lucide-react'

export function ReportsPage() {
  const { businessId } = useParams<{ businessId: string }>()

  const reports = [
    {
      id: 'monthly-performance',
      title: 'Laporan Performa Bulanan',
      description: 'Cetak ringkasan P&L, arus kas, dan margin untuk bulan berjalan.',
      icon: BarChart2,
      color: 'text-blue-400'
    },
    {
      id: 'simulation',
      title: 'Laporan Simulasi Skenario',
      description: 'Laporan proyeksi masa depan berdasarkan skenario optimis/moderat/konservatif.',
      icon: TrendingUp,
      color: 'text-emerald-400'
    },
    {
      id: 'investor',
      title: 'Laporan Investor (Investor Report)',
      description: 'Ringkasan kesehatan bisnis, porsi ekuitas, dan ROI untuk dibagikan ke investor.',
      icon: Briefcase,
      color: 'text-purple-400'
    },
    {
      id: 'capital-usage',
      title: 'Laporan Penggunaan Modal',
      description: 'Lacak sisa Affordable Loss dan riwayat suntikan dana.',
      icon: DollarSign,
      color: 'text-amber-400'
    }
  ]

  return (
    <div className="space-y-6 pb-20">
      <div>
        <h1 className="text-2xl font-bold text-slate-100">Laporan Ekspor & Cetak</h1>
        <p className="text-sm text-slate-400 mt-1">Hasilkan laporan PDF profesional untuk keperluan internal maupun investor.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {reports.map(report => (
          <div key={report.id} className="bg-slate-900 border border-slate-800 rounded-xl p-6 shadow-sm hover:border-slate-700 transition-colors flex flex-col justify-between">
            <div className="flex gap-4 items-start mb-6">
              <div className="p-3 bg-slate-800 rounded-lg shrink-0">
                <report.icon size={24} className={report.color} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-slate-200 mb-1">{report.title}</h3>
                <p className="text-sm text-slate-400">{report.description}</p>
              </div>
            </div>
            <Link 
              to={`/businesses/${businessId}/reports/${report.id}`}
              className="flex justify-center items-center gap-2 w-full py-2 bg-slate-800 hover:bg-slate-700 text-slate-200 rounded-lg transition-colors text-sm font-medium"
            >
              <FileText size={16} /> Lihat Laporan
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}
